import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import deTexts from './DynamicClockDe.json';
import enTexts from './DynamicClockEn.json';
import styles from './DynamicClock.module.css';

const DynamicClockProject = () => {
    const { i18n } = useTranslation();
    const texts = i18n.language.startsWith('de') ? deTexts : enTexts;

    // Separate Refs für jeden Zeiger
    const clockRef = useRef(null);
    const hourHandRef = useRef(null);
    const minuteHandRef = useRef(null);
    const secondHandRef = useRef(null);

    useEffect(() => {
        const updateClock = () => {
            const now = new Date();
            const hours = now.getHours();
            const minutes = now.getMinutes();
            const seconds = now.getSeconds();

            const hourDegree = (hours / 12) * 360;
            const minuteDegree = (minutes / 60) * 360;
            const secondDegree = (seconds / 60) * 360;

            const hourHand = hourHandRef.current;
            const minuteHand = minuteHandRef.current;
            const secondHand = secondHandRef.current;
            if (!hourHand || !minuteHand || !secondHand) return;

            // Greife über die Refs auch direkt auf die Container für die Zahlen zu
            const hourNumber = hourHand.querySelector(`.${styles.hourNumber}`);
            const minuteNumber = minuteHand.querySelector(`.${styles.minuteNumber}`);
            const secondNumber = secondHand.querySelector(`.${styles.secondNumber}`);

            if (!hourNumber || !minuteNumber || !secondNumber) return;

            // Alte Inhalte entfernen
            hourNumber.innerHTML = '';
            minuteNumber.innerHTML = '';
            secondNumber.innerHTML = '';

            // Zahlen zur Stundenhand hinzufügen (3 Zahlen)
            for (let i = 1; i <= 3; i++) {
                const div = document.createElement('div');
                div.textContent = hours.toString();
                div.style.transform = `translateY(-${i * 3.5}vw) rotate(${-hourDegree}deg)`;
                hourNumber.appendChild(div);
            }

            // Zahlen zur Minutenhand hinzufügen (4 Zahlen)
            for (let i = 1; i <= 4; i++) {
                const div = document.createElement('div');
                div.textContent = minutes.toString();
                div.style.transform = `translateY(-${i * 3.5}vw) rotate(${-minuteDegree}deg)`;
                minuteNumber.appendChild(div);
            }

            // Zahlen zur Sekundenhand hinzufügen (5 Zahlen)
            for (let i = 1; i <= 5; i++) {
                const div = document.createElement('div');
                div.textContent = seconds.toString();
                div.style.transform = `translateY(-${i * 3.5}vw) rotate(${-secondDegree}deg)`;
                secondNumber.appendChild(div);
            }

            // Zeiger rotieren
            secondHand.style.transform = `translate(-50%, -50%) rotate(${secondDegree}deg)`;
            minuteHand.style.transform = `translate(-50%, -50%) rotate(${minuteDegree}deg)`;
            hourHand.style.transform = `translate(-50%, -50%) rotate(${hourDegree}deg)`;
        };

        updateClock();
        const interval = setInterval(updateClock, 1000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className={styles.dynamicClockProject} id="dynamicClock">
            <div className={styles.content}>
                {/* Linker Bereich: Dynamische Uhr */}
                <div className={styles.clockWrapper} ref={clockRef}>
                    <div className={styles.secondHand} ref={secondHandRef}>
                        <div className={styles.secondNumber}></div>
                    </div>
                    <div className={styles.minuteHand} ref={minuteHandRef}>
                        <div className={styles.minuteNumber}></div>
                    </div>
                    <div className={styles.hourHand} ref={hourHandRef}>
                        <div className={styles.hourNumber}></div>
                    </div>
                    <div className={styles.center}></div>
                </div>
                {/* Rechter Bereich: Text */}
                <div className={styles.description}>
                    <h2>{texts.title}</h2>
                    <p>{texts.description}</p>
                    <a
                        href="https://github.com/d0ener4ever/AnalogDigitalClock"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        GitHub Repository
                    </a>
                </div>
            </div>
        </div>
    );
};

export default DynamicClockProject;
